import React from 'react';

const CloseButton = ({ onClick, className = '', ariaLabel = 'Close modal' }) => {
  return (
    <button 
      className={className} 
      onClick={onClick} 
      aria-label={ariaLabel}
      type="button"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path 
          d="M18 6L6 18M6 6l12 12" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
};

export default CloseButton;

